import React, { useState, useEffect } from "react";
// import useSWR from "swr";
import { useVisitorDetails } from "./VisitorDetailsContext";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import TopActionMenus from "./TopActionMenus";
import DashboardContentFooter from "./DashboardContentFooter";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigationEvent } from "navigation-react";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes" });
const BASE_URL = process.env.REACT_APP_DRUPAL_BASE_URL;

// SWR fetcher with credentials
// const fetcher = (url) =>
//   fetch(url, { credentials: "include" }).then((res) => {
//     if (!res.ok) throw new Error(`Fetch error ${res.status} ${res.statusText}`);
//     return res.json();
//   });

// Get authentication headers (CSRF token required)
const getAuthHeaders = () => {
  const csrfToken = ls.get("usercsrf_token");
  if (!csrfToken) throw new Error("No authentication credentials available");
  return {
    "Content-Type": "application/vnd.api+json",
    Accept: "application/vnd.api+json",
    "X-CSRF-Token": csrfToken,
  };
};

export default function DeliveriesEditRegister() {
  const { stateNavigator, data } = useNavigationEvent();
  // eslint-disable-next-line no-unused-vars
  const { selectedVisitor } = useVisitorDetails();

  const [deliveredByValue, setDeliveredByValue] = useState(data?.deliveredBy);
  const [notescommentValue, setNotescommentValue] = useState(
    data?.deliveryNotesComment
  );
  const [deliveredCompanyValue, setDeliveredCompanyValue] = useState(
    data?.deliveryCompany
  );
  const [deliveredContactValue, setDeliveredContactValue] = useState(
    data?.deliveryContact
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Redirect if not logged in
  useEffect(() => {
    const csrfToken = ls.get("usercsrf_token");
    const username = ls.get("username");
    if (!csrfToken || !username) {
      alert("You are not logged in. Redirecting to login page.");
      stateNavigator.navigate("login");
    }
  }, [stateNavigator]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!deliveredCompanyValue || !deliveredByValue || !notescommentValue) {
      alert("Please fill all required fields");
      return;
    }

    setIsSubmitting(true);

    try {
      const headers = getAuthHeaders();

      const payload = {
        data: {
          type: "node--deliveries",
          id: data?.deliveryUUID,
          attributes: {
            field_delivered_by: deliveredByValue,
            field_delivery_company: deliveredCompanyValue,
            field_delivery_notes_comments: notescommentValue,
            field_delivery_contact_number: deliveredContactValue,
          },
        },
      };

      const response = await fetch(
        `${BASE_URL}/jsonapi/node/deliveries/${data?.deliveryUUID}`,
        {
          method: "PATCH",
          headers,
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        alert(`Failed to update delivery. ${errorText}`);
        setIsSubmitting(false);
        return;
      }

      const result = await response.json();
      console.log("Delivery updated:", result);

      alert("Delivery updated successfully");
      setIsSubmitting(false);
      stateNavigator.navigate("deliveriesregister");
    } catch (err) {
      console.error("Update error:", err);
      alert(`Error updating delivery: ${err.message}`);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div className="patient-register">
          <TopActionMenus
            AddTitle="Edit Delivery details"
            backIcon={faArrowLeft}
            backNavigationLink={"deliveriesregister"}
          />
          <form
            className="patient-form"
            onSubmit={handleSubmit}
            style={{ width: "60%", margin: "0 auto" }}
          >
            <div className="form-group">
              <label>Delivered By</label>
              <input
                type="text"
                value={deliveredByValue}
                onChange={(e) => setDeliveredByValue(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Delivery Company</label>
              <input
                type="text"
                value={deliveredCompanyValue}
                onChange={(e) => setDeliveredCompanyValue(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Delivery Contact</label>
              <input
                type="text"
                value={deliveredContactValue}
                onChange={(e) => setDeliveredContactValue(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Notes / Comments</label>
              <input
                type="text"
                value={notescommentValue}
                onChange={(e) => setNotescommentValue(e.target.value)}
                required
              />
            </div>

            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Updating..." : "Update Delivery"}
            </button>
          </form>
        </div>
      </div>
      <DashboardContentFooter />
    </div>
  );
}
